/** Form field names used in the provider search. */
export const FIELDS = {
  npi: 'npi',
  locationCity: 'locationCity',
  name: 'name',
  last4: 'last4',
  email: 'email',

  /** Hidden field: set only when last4 is API-verified. Empty = unverified or loading. */
  verifiedLast4: 'verifiedLast4',
};

/** Tailwind CSS classes for form inputs that include a right-side icon (extra padding). */
export const INPUT_WITH_ICON_PADDING_CLASSES = 'w-full pr-10';
